import * as GeneralRepository from "./general-repository";
import * as SolicitudMultipleProvider from "../providers/solicitud-multiple-provider";

export const obtenerEstadoSolicitudMultiple = async (idSolicitudMultiple) => {
    const response = await SolicitudMultipleProvider.getEstados(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            estado: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerEstadoSolicitudMultiple(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    estado: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                estado: null
            }
        }
    }
}

export const registrarSolicitudMultiple = async (codigoIntermediario, idProspecto, codigoCotizacion, usuario, request, indicador) => {
    let solicitudMultiple = {
        intermediarioRequest: request,
        codigoIntermediario: codigoIntermediario,
        idProspecto: idProspecto,
        codigoCotizacion: codigoCotizacion,
        usuario: usuario,
        indicadorIntermediarioDiferente: indicador === null ? false : indicador
    }
    const response = await SolicitudMultipleProvider.registrarSolicitudMultiple(solicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            solicitudMultiple: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await registrarSolicitudMultiple(codigoIntermediario, idProspecto, codigoCotizacion, usuario, request, indicador)
            } else {
                return {
                    error: response.auditResponse,
                    solicitudMultiple: null
                }
            }
        } else {
            let responseError = null
            if (response.auditResponse.codigoRespuesta === 400) {
                if (response.auditResponse.mensajeRespuesta.includes('VALIDACION DE NEGOCIO')) {
                    let mensaje = response.auditResponse.mensajeRespuesta.slice(23)
                    responseError = {
                        ...response.auditResponse,
                        mensajeRespuesta: mensaje
                    }
                } else {
                    responseError = response.auditResponse
                }
            } else {
                responseError = response.auditResponse
            }
            return {
                error: responseError,
                solicitudMultiple: null
            }
        }
    }
}